<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        title="检验项维护"
        class="customer-edit"
        width="1000px"
        top="5vh">
      <el-button type="primary" style="margin-bottom: 3%" @click="materialsTest">新建</el-button>
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="inspectionItems/materialId">
        <el-table-column prop="rowIndex" align="center" label="序号"/>
        <el-table-column prop="inspectionType" align="center" label="检验项类型">
          <template slot-scope="scope">
            <span>{{itemDataTypes[scope.row.itemDataType]}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionType" align="center" label="检验类型">
          <template slot-scope="scope">
            <span>{{inspectionTypes[scope.row.inspectionType]}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="名称"/>
        <el-table-column prop="inspectionStandard" align="center" label="检验标准"/>
        <el-table-column prop="inspectionStation" align="center" label="站点">
          <template slot-scope="scope">
            <span>{{inspectionStations[scope.row.inspectionStation]}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionMethod" align="center" label="检验方式">
          <template slot-scope="scope">
            <span>{{inspectionMethods[scope.row.inspectionMethod]}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            width="120">
          <template slot-scope="scope">
            <el-button type="waring" @click="deleteRow(scope.row)">删除</el-button>
            <el-button type="primary" @click="$refs.materialsTest.open(0,scope.row.pkid)">编辑</el-button>
          </template>
        </el-table-column>
      </vm-table>
    </el-dialog>
    <material-guid-create ref="materialsTest" @save-success="getList(-1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import constant from "@/util/constant";
  import MaterialGuidCreate from "@/views/information/MaterialManagement/MaterialGuidCreate";

  export default {
    name:"MaterialGuidTable",
    components: { MaterialGuidCreate,VmTable},
    data() {
      return {
        inspectionTypes: constant.inspectionType,
        itemDataTypes: constant.itemDataType,
        inspectionStations: constant.inspectionStation,
        inspectionMethods: constant.inspectionMethod,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        materials: {
          id: 0,
        },
        ruleValidate: {
        },
        filter: {
          materialId: 0,
        },
      };
    },
    methods: {
      open(row) {
        this.materials.id = row.id;
        this.filter.materialId = row.id;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      materialsTest() {
        this.$refs.materialsTest.open(this.materials.id,0);
      },
      deleteRow(row) {
        let idList = [];
        idList.push(this.materials.id);
        idList.push(row.pkid);
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","inspectionItems/idList",idList).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
